var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconCherry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8844 6.27679H10.3394V8.82189H12.8844V6.27679Z",
    fill: "#59131B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4282 6.27679H12.884V8.82189H15.4282V6.27679Z",
    fill: "#59131B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6969 13.9102H28.1519V16.4553H30.6969V13.9102Z",
    fill: "#FFBEC2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2414 13.9102H30.6963V16.4553H33.2414V13.9102Z",
    fill: "#FFBEC2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8844 13.9102H10.3394V16.4553H12.8844V13.9102Z",
    fill: "#FF8292"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4282 13.9102H12.884V16.4553H15.4282V13.9102Z",
    fill: "#FF8292"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3398 16.4553H7.79468V19.0004H10.3398V16.4553Z",
    fill: "#FF8292"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8844 16.4553H10.3394V19.0004H12.8844V16.4553Z",
    fill: "#FF8292"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8844 19.0005H10.3394V21.5447H12.8844V19.0005Z",
    fill: "#FF8292"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4282 19.0005H12.884V21.5447H15.4282V19.0005Z",
    fill: "#FF8292"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8844 21.5446H10.3394V24.0897H12.8844V21.5446Z",
    fill: "#FF8292"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4282 21.5446H12.884V24.0897H15.4282V21.5446Z",
    fill: "#FF8292"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4282 24.0898H12.884V26.634H15.4282V24.0898Z",
    fill: "#FF8292"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9727 24.0898H15.4285V26.634H17.9727V24.0898Z",
    fill: "#FF8292"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3394 26.6339V29.179H12.8844V26.6339H10.3394Z",
    fill: "#FF6B75"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3394 24.0898V26.634H12.8844V24.0898H10.3394Z",
    fill: "#FF6B75"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.884 29.179V31.7232H15.4282V29.179H12.884Z",
    fill: "#FF6B75"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.884 26.6339V29.179H15.4282V26.6339H12.884Z",
    fill: "#FF6B75"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4285 31.7232V34.2683H17.9727V31.7232H15.4285Z",
    fill: "#FF6B75"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4285 29.179V31.7232H17.9727V29.179H15.4285Z",
    fill: "#FF6B75"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9727 26.6339H15.4285V29.179H17.9727V26.6339Z",
    fill: "#FF8292"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5182 26.6339H17.9731V29.179H20.5182V26.6339Z",
    fill: "#FF8292"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5182 29.179H17.9731V31.7232H20.5182V29.179Z",
    fill: "#FF8292"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0629 29.179H20.5178V31.7232H23.0629V29.179Z",
    fill: "#FF8292"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6067 29.179H23.0625V31.7232H25.6067V29.179Z",
    fill: "#FF8292"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1514 29.179H25.6072V31.7232H28.1514V29.179Z",
    fill: "#FF8292"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6969 24.0898H28.1519V26.634H30.6969V24.0898Z",
    fill: "#FFBEC2"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2414 24.0898H30.6963V26.634H33.2414V24.0898Z",
    fill: "#FFBEC2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 24.0898V26.634H7.79419V24.0898H5.25Z",
    fill: "#59131B"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 19.0005V21.5447H7.79419V19.0005H5.25Z",
    fill: "#59131B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 21.5446V24.0897H7.79419V21.5446H5.25Z",
    fill: "#59131B"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 16.4553V19.0004H7.79419V16.4553H5.25Z",
    fill: "#59131B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9727 34.2683H15.4285V36.8125H17.9727V34.2683Z",
    fill: "#59131B"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0629 34.2683H20.5178V36.8125H23.0629V34.2683Z",
    fill: "#59131B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5182 34.2683H17.9731V36.8125H20.5182V34.2683Z",
    fill: "#59131B"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6067 34.2683H23.0625V36.8125H25.6067V34.2683Z",
    fill: "#59131B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.241 24.0898V26.634H35.7852V24.0898H33.241Z",
    fill: "#59131B"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.241 19.0005V21.5447H35.7852V19.0005H33.241Z",
    fill: "#59131B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.241 13.9102V16.4553H35.7852V13.9102H33.241Z",
    fill: "#59131B"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.241 21.5446V24.0897H35.7852V21.5446H33.241Z",
    fill: "#59131B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.241 16.4553V19.0004H35.7852V16.4553H33.241Z",
    fill: "#59131B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1519 19.0004H30.6969V16.4553H28.1519V19.0004Z",
    fill: "#FFBEC2"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0625 19.0004H25.6067V16.4553H23.0625V19.0004Z",
    fill: "#FFBEC2"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9731 19.0004H20.5182V16.4553H17.9731V19.0004Z",
    fill: "#FFBEC2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6072 19.0004H28.1514V16.4553H25.6072V19.0004Z",
    fill: "#FFBEC2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5178 19.0004H23.0629V16.4553H20.5178V19.0004Z",
    fill: "#FFBEC2"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6963 24.0897H33.2414V21.5446H30.6963V24.0897Z",
    fill: "#FFBEC2"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6072 24.0897H28.1514V21.5446H25.6072V24.0897Z",
    fill: "#FFBEC2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5178 24.0897H23.0629V21.5446H20.5178V24.0897Z",
    fill: "#FFBEC2"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1519 24.0897H30.6969V21.5446H28.1519V24.0897Z",
    fill: "#FFBEC2"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0625 24.0897H25.6067V21.5446H23.0625V24.0897Z",
    fill: "#FFBEC2"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1519 21.5447H30.6969V19.0005H28.1519V21.5447Z",
    fill: "#FFBEC2"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0625 21.5447H25.6067V19.0005H23.0625V21.5447Z",
    fill: "#FFBEC2"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9731 21.5447H20.5182V19.0005H17.9731V21.5447Z",
    fill: "#FFBEC2"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6072 21.5447H28.1514V19.0005H25.6072V21.5447Z",
    fill: "#FFBEC2"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5178 21.5447H23.0629V19.0005H20.5178V21.5447Z",
    fill: "#FFBEC2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6067 8.8219H23.0625V11.3661H25.6067V8.8219Z",
    fill: "#59131B"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6969 8.8219H28.1519V11.3661H30.6969V8.8219Z",
    fill: "#59131B"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1514 8.8219H25.6072V11.3661H28.1514V8.8219Z",
    fill: "#59131B"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4282 8.8219H12.884V11.3661H15.4282V8.8219Z",
    fill: "#59131B"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5182 8.8219H17.9731V11.3661H20.5182V8.8219Z",
    fill: "#59131B"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9727 8.8219H15.4285V11.3661H17.9727V8.8219Z",
    fill: "#59131B"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4282 11.3661H12.884V13.9103H15.4282V11.3661Z",
    fill: "#FFBEC2"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5182 11.3661H17.9731V13.9103H20.5182V11.3661Z",
    fill: "#FFBEC2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9727 11.3661H15.4285V13.9103H17.9727V11.3661Z",
    fill: "#FFBEC2"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5182 31.7232H17.9731V34.2683H20.5182V31.7232Z",
    fill: "#FF6B75"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6067 31.7232H23.0625V34.2683H25.6067V31.7232Z",
    fill: "#FF6B75"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0629 31.7232H20.5178V34.2683H23.0629V31.7232Z",
    fill: "#FF6B75"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79468 24.0898V26.634H10.3398V24.0898H7.79468Z",
    fill: "#FF6B75"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79468 19.0005V21.5447H10.3398V19.0005H7.79468Z",
    fill: "#FF6B75"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79468 21.5446V24.0897H10.3398V21.5446H7.79468Z",
    fill: "#FF6B75"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9727 13.9102H15.4285V16.4553H17.9727V13.9102Z",
    fill: "#FFBEC2"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0629 13.9102H20.5178V16.4553H23.0629V13.9102Z",
    fill: "#FFBEC2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5182 13.9102H17.9731V16.4553H20.5182V13.9102Z",
    fill: "#FFBEC2"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6067 11.3661H23.0625V13.9103H25.6067V11.3661Z",
    fill: "#FFA6AA"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6969 11.3661H28.1519V13.9103H30.6969V11.3661Z",
    fill: "#FFA6AA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1514 11.3661H25.6072V13.9103H28.1514V11.3661Z",
    fill: "#FFA6AA"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8844 1.1875H10.3394V3.73259H12.8844V1.1875Z",
    fill: "#59131B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9727 1.1875H15.4285V3.73259H17.9727V1.1875Z",
    fill: "#59131B"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4282 1.1875H12.884V3.73259H15.4282V1.1875Z",
    fill: "#59131B"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5182 1.1875H17.9731V3.73259H20.5182V1.1875Z",
    fill: "#59131B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9727 3.73267H15.4285V6.27685H17.9727V3.73267Z",
    fill: "#0FAE00"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4282 3.73267H12.884V6.27685H15.4282V3.73267Z",
    fill: "#0FAE00"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5182 3.73267H17.9731V6.27685H20.5182V3.73267Z",
    fill: "#0FAE00"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5182 6.27679H17.9731V8.82189H20.5182V6.27679Z",
    fill: "#0FAE00"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9727 6.27679H15.4285V8.82189H17.9727V6.27679Z",
    fill: "#0FAE00"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0629 6.27679H20.5178V8.82189H23.0629V6.27679Z",
    fill: "#59131B"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8844 3.73267H10.3394V6.27685H12.8844V3.73267Z",
    fill: "#59131B"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0629 3.73267H20.5178V6.27685H23.0629V3.73267Z",
    fill: "#59131B"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0629 11.3661H20.5178V13.9103H23.0629V11.3661Z",
    fill: "#59131B"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6067 13.9102H23.0625V16.4553H25.6067V13.9102Z",
    fill: "#59131B"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2414 16.4553H30.6963V19.0004H33.2414V16.4553Z",
    fill: "#FFBEC2"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2414 19.0005H30.6963V21.5447H33.2414V19.0005Z",
    fill: "#FFBEC2"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4282 16.4553H12.884V19.0004H15.4282V16.4553Z",
    fill: "#FFA6AA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9727 16.4553H15.4285V19.0004H17.9727V16.4553Z",
    fill: "#FF8292"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9727 19.0005H15.4285V21.5447H17.9727V19.0005Z",
    fill: "#FFBEC2"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9727 21.5446H15.4285V24.0897H17.9727V21.5446Z",
    fill: "#FFBEC2"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5182 24.0898H17.9731V26.634H20.5182V24.0898Z",
    fill: "#FFBEC2"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0629 26.6339H20.5178V29.179H23.0629V26.6339Z",
    fill: "#FFBEC2"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6067 24.0898H23.0625V26.634H25.6067V24.0898Z",
    fill: "#FFBEC2"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1514 26.6339H25.6072V29.179H28.1514V26.6339Z",
    fill: "#FFBEC2"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6067 26.6339H23.0625V29.179H25.6067V26.6339Z",
    fill: "#FF8292"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1514 24.0898H25.6072V26.634H28.1514V24.0898Z",
    fill: "#FF8292"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0629 24.0898H20.5178V26.634H23.0629V24.0898Z",
    fill: "#FF8292"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5182 21.5446H17.9731V24.0897H20.5182V21.5446Z",
    fill: "#FF8292"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6969 26.6339H28.1519V29.179H30.6969V26.6339Z",
    fill: "#FF8292"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1514 13.9102H25.6072V16.4553H28.1514V13.9102Z",
    fill: "#FFA6AA"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0629 8.8219H20.5178V11.3661H23.0629V8.8219Z",
    fill: "#0FAE00"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6067 6.27679H23.0625V8.82189H25.6067V6.27679Z",
    fill: "#59131B"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2414 11.3661H30.6963V13.9103H33.2414V11.3661Z",
    fill: "#59131B"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.2414 26.6339H30.6963V29.179H33.2414V26.6339Z",
    fill: "#59131B"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.79468 26.6339H10.3398V29.179H7.79468V26.6339Z",
    fill: "#59131B"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.6969 29.179H28.1519V31.7232H30.6969V29.179Z",
    fill: "#59131B"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8844 11.3661H10.3394V13.9103H12.8844V11.3661Z",
    fill: "#59131B"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3394 29.179H12.8844V31.7232H10.3394V29.179Z",
    fill: "#59131B"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.1514 31.7232H25.6072V34.2683H28.1514V31.7232Z",
    fill: "#59131B"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3398 13.9102H7.79468V16.4553H10.3398V13.9102Z",
    fill: "#59131B"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.884 31.7232H15.4282V34.2683H12.884V31.7232Z",
    fill: "#59131B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCherry);
export default __webpack_public_path__ + "static/media/IconCherry.8073f2cb04df4d5070a93dc397fe6913.svg";
export { ForwardRef as ReactComponent };